export default __webpack_public_path__ + "static/media/back-arrow.b8cd184f.svg";